import Authorized from './authorized';
import Policy from '@pansy/policy';
import checkAuthority from './check-authority';

export default Authorized;
export { AuthorizedProps } from './authorized';
export {
  Policy,
  checkAuthority
}
